<template>
  <div class="myLoadBack">
    <div class="bgrLoad">
      <div class="cont">
        <div class="paper"></div> <button>
          <div class="delloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>Deleting
        </button>
        <div class="g-cont">
          <div class="garbage"></div>
          <div class="garbage"></div>
          <div class="garbage"></div>
          <div class="garbage"></div>
          <div class="garbage"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'delassesLoader',
  props: {}
}
</script>
<style scoped>
.myLoadBack {
  z-index: 10000002;
}
</style>